// extracted by mini-css-extract-plugin
export default {"cls1":"GWKCWJJe1rD7fRezjVav","cls2":"V6Aa8EKOdZQGxK4N0hX_ GWKCWJJe1rD7fRezjVav"};